import { useMemo } from 'react';

import Button from '@placekit/uikit/components/Button';
import Icon from '@placekit/uikit/components/Icon';

import PricingCalculator from 'components/PricingCalculator';
import Section from 'components/Section';
import { useT } from 'i18n';
import { pricingVars } from 'utils/pricing';

const BENEFITS = [
  ['payg', 'arrow-trending-up'],
  ['volume', 'receipt-percent'],
  ['transparent', 'cube-transparent'],
];

const Pricing = () => {
  const t = useT();
  const vars = useMemo(() => pricingVars(t.locale), [t.locale]);
  const benefits = useMemo(
    () => BENEFITS.map(([key, icon]) => ({ icon, ...t(`home.pricing.benefits.${key}`, vars) })),
    [t, vars],
  );

  return (
    <Section id="pricing" theme="gradient-accent" className="border-y! border-accent-400!">
      <Section.Header size="medium" center={true} title={t('home.pricing.title')}>
        <p className="mt-6 font-bold text-lg tracking-wide text-accent-100">
          {t('home.pricing.tagline')}
        </p>
        <p className="tracking-wide text-accent-200">{t('home.pricing.subtitle')}</p>
      </Section.Header>

      {/* spacing from Section `space-y-12` only, as Tailwind 3 rendered it (its own margins lost) */}
      <PricingCalculator className="shadow-lg" />

      <dl className="space-y-10 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8">
        {benefits.map((item, i) => (
          <div key={i.toString()} className="relative">
            <dt>
              <div className="absolute lg:static flex items-center justify-center h-12 w-12 rounded-md bg-accent-600">
                <Icon name={item.icon} size="medium" aria-hidden="true" />
              </div>
              <p className="mt-5 ml-16 lg:ml-0 text-lg leading-6 font-medium text-white">
                {item.title}
              </p>
            </dt>
            <dd className="mt-2 ml-16 lg:ml-0 text-base text-accent-200">{item.description}</dd>
          </div>
        ))}
      </dl>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-y-4 sm:gap-y-0 sm:gap-x-6">
        <Button
          href="https://app.placekit.io/auth/register"
          label={t('common.cta.getStartedFree')}
          kind="secondary"
          size="medium"
        />
        <Button
          href={t.path('/pricing')}
          label={t('common.cta.pricingDetails')}
          kind="none"
          size="medium"
          className="bg-accent-700 shadow-xs text-white hover:bg-accent-800 focus:bg-accent-800"
        />
      </div>
    </Section>
  );
};

export default Pricing;
